import script from "./StatisticalDept.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticalDept.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticalDept.vue?vue&type=style&index=0&id=288cfcfa&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-288cfcfa"]])

export default __exports__